import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Links from './pages/Links';
import Commands from './pages/Commands';
import Channels from './pages/Channels';
import CountConfig from './pages/CountConfig';
import CustomCounters from './pages/CustomCounters';
import Tasks from './pages/Tasks';
import Points from './pages/Points';
import Rules from './pages/Rules';
import Rewards from './pages/Rewards';
import Media from './pages/Media';
import Punishments from './pages/Punishments';
import CheckIns from './pages/CheckIns';
import Inspections from './pages/Inspections';
import Control from './pages/Control';
import Protocols from './pages/Protocols';
import Characters from './pages/Characters';
import Scenes from './pages/Scenes';
import Glamours from './pages/Glamours';
import Venues from './pages/Venues';
import Training from './pages/Training';
import Journals from './pages/Journals';
import Contracts from './pages/Contracts';
import ActivityLog from './pages/ActivityLog';
import Settings from './pages/Settings';
import MorningReports from './pages/MorningReports';
import EveningReports from './pages/EveningReports';
import SpeechRules from './pages/SpeechRules';
import ClothingRules from './pages/ClothingRules';
import GroomingSchedule from './pages/GroomingSchedule';
import SleepConfig from './pages/SleepConfig';
import FoodRules from './pages/FoodRules';
import OrgasmControl from './pages/OrgasmControl';
import WeekPlanning from './pages/WeekPlanning';
import MonthPlanning from './pages/MonthPlanning';
import SafetySystem from './pages/SafetySystem';
import ActivitySessions from './pages/ActivitySessions';
import Toys from './pages/Toys';
import Sessions from './pages/Sessions';
import Challenges from './pages/Challenges';
import Routines from './pages/Routines';
import Aftercare from './pages/Aftercare';
import Limits from './pages/Limits';
import MediaTasks from './pages/MediaTasks';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import { getCurrentUser } from './services/api';
import './styles/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const userData = await getCurrentUser();
      setUser(userData);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  const authRoute = (Component) => user ? <Component user={user} /> : <Navigate to="/login" />;

  return (
    <ErrorBoundary>
    <ToastProvider>
    <Router>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={authRoute(Dashboard)} />
        <Route path="/links" element={authRoute(Links)} />
        <Route path="/commands" element={authRoute(Commands)} />
        <Route path="/channels" element={authRoute(Channels)} />
        <Route path="/count-config" element={authRoute(CountConfig)} />
        <Route path="/custom-counters" element={authRoute(CustomCounters)} />
        <Route path="/tasks" element={authRoute(Tasks)} />
        <Route path="/points" element={authRoute(Points)} />
        <Route path="/rules" element={authRoute(Rules)} />
        <Route path="/rewards" element={authRoute(Rewards)} />
        <Route path="/media" element={authRoute(Media)} />
        <Route path="/punishments" element={authRoute(Punishments)} />
        <Route path="/checkins" element={authRoute(CheckIns)} />
        <Route path="/inspections" element={authRoute(Inspections)} />
        <Route path="/control" element={authRoute(Control)} />
        <Route path="/protocols" element={authRoute(Protocols)} />
        <Route path="/characters" element={authRoute(Characters)} />
        <Route path="/scenes" element={authRoute(Scenes)} />
        <Route path="/glamours" element={authRoute(Glamours)} />
        <Route path="/venues" element={authRoute(Venues)} />
        <Route path="/training" element={authRoute(Training)} />
        <Route path="/journals" element={authRoute(Journals)} />
        <Route path="/contracts" element={authRoute(Contracts)} />
        <Route path="/activity-log" element={authRoute(ActivityLog)} />
        <Route path="/settings" element={authRoute(Settings)} />
        <Route path="/morning-reports" element={authRoute(MorningReports)} />
        <Route path="/evening-reports" element={authRoute(EveningReports)} />
        <Route path="/speech-rules" element={authRoute(SpeechRules)} />
        <Route path="/clothing-rules" element={authRoute(ClothingRules)} />
        <Route path="/grooming" element={authRoute(GroomingSchedule)} />
        <Route path="/sleep" element={authRoute(SleepConfig)} />
        <Route path="/food" element={authRoute(FoodRules)} />
        <Route path="/orgasm-control" element={authRoute(OrgasmControl)} />
        <Route path="/week-planning" element={authRoute(WeekPlanning)} />
        <Route path="/month-planning" element={authRoute(MonthPlanning)} />
        <Route path="/safety" element={authRoute(SafetySystem)} />
        <Route path="/activity-sessions" element={authRoute(ActivitySessions)} />
        <Route path="/toys" element={authRoute(Toys)} />
        <Route path="/sessions" element={authRoute(Sessions)} />
        <Route path="/challenges" element={authRoute(Challenges)} />
        <Route path="/routines" element={authRoute(Routines)} />
        <Route path="/aftercare" element={authRoute(Aftercare)} />
        <Route path="/limits" element={authRoute(Limits)} />
        <Route path="/media-tasks" element={authRoute(MediaTasks)} />
        <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
